// @ts-nocheck
import { createAsyncActionTypes } from '../../../core/store/actionCreators';

export const FETCH_COMPANIES = 'company/fetchCompanies';
export const {
  pending: FETCH_COMPANIES_PENDING,
  fulfilled: FETCH_COMPANIES_FULFILLED,
  rejected: FETCH_COMPANIES_REJECTED,
} = createAsyncActionTypes(FETCH_COMPANIES);

export const FETCH_COMPANY = 'company/fetchCompany';
export const {
  pending: FETCH_COMPANY_PENDING,
  fulfilled: FETCH_COMPANY_FULFILLED,
  rejected: FETCH_COMPANY_REJECTED,
} = createAsyncActionTypes(FETCH_COMPANY);

export const FETCH_CONTRACT = 'company/fetchContract';
export const {
  pending: FETCH_CONTRACT_PENDING,
  fulfilled: FETCH_CONTRACT_FULFILLED,
  rejected: FETCH_CONTRACT_REJECTED,
} = createAsyncActionTypes(FETCH_CONTRACT);

export const FETCH_PRODUCTS = 'company/fetchProducts';
export const {
  pending: FETCH_PRODUCTS_PENDING,
  fulfilled: FETCH_PRODUCTS_FULFILLED,
  rejected: FETCH_PRODUCTS_REJECTED,
} = createAsyncActionTypes(FETCH_PRODUCTS);

export const CREATE_COMPANY = 'company/createCompany';
export const {
  pending: CREATE_COMPANY_PENDING,
  fulfilled: CREATE_COMPANY_FULFILLED,
  rejected: CREATE_COMPANY_REJECTED,
} = createAsyncActionTypes(CREATE_COMPANY);

export const UPDATE_COMPANY = 'company/updateCompany';
export const {
  pending: UPDATE_COMPANY_PENDING,
  fulfilled: UPDATE_COMPANY_FULFILLED,
  rejected: UPDATE_COMPANY_REJECTED,
} = createAsyncActionTypes(UPDATE_COMPANY);

export const CREATE_CONTRACT = 'company/createContract';
export const {
  pending: CREATE_CONTRACT_PENDING,
  fulfilled: CREATE_CONTRACT_FULFILLED,
  rejected: CREATE_CONTRACT_REJECTED,
} = createAsyncActionTypes(CREATE_CONTRACT);

export const CLOSE_CONTRACT = 'company/closeContract';
export const {
  pending: CLOSE_CONTRACT_PENDING,
  fulfilled: CLOSE_CONTRACT_FULFILLED,
  rejected: CLOSE_CONTRACT_REJECTED,
} = createAsyncActionTypes(CLOSE_CONTRACT);

export const ACTIVATE_CONTRACT = 'company/activateContract';
export const {
  pending: ACTIVATE_CONTRACT_PENDING,
  fulfilled: ACTIVATE_CONTRACT_FULFILLED,
  rejected: ACTIVATE_CONTRACT_REJECTED,
} = createAsyncActionTypes(ACTIVATE_CONTRACT);

export const ADD_USERS_TO_CONTRACT = 'company/addUsersToContract';
export const {
  pending: ADD_USERS_TO_CONTRACT_PENDING,
  fulfilled: ADD_USERS_TO_CONTRACT_FULFILLED,
  rejected: ADD_USERS_TO_CONTRACT_REJECTED,
} = createAsyncActionTypes(ADD_USERS_TO_CONTRACT);
